export const SET_WORKSTATIONS = 'SET_WORKSTATIONS';
export const SET_ACTIVEWORKSTATIONS = 'SET_ACTIVEWORKSTATIONS';
export const SET_SELECTEDWORKSTATION = 'SET_SELECTEDWORKSTATION';
export const SET_MACHINEPARAMETERS = 'SET_MACHINEPARAMETERS';
export const SET_WORKSTATIONSTATUSSES = 'SET_WORKSTATIONSTATUSSES';
export const SET_RESTRICTIONS = 'SET_RESTRICTIONS';
export const SET_WORKINGHOURS = 'SET_WORKINGHOURS';
export const SET_RESTRICTIONTYPES = 'SET_RESTRICTIONTYPES';
export const SET_WORKSTATIONNOTIFICATIONSDRAWEROPEN = 'SET_WORKSTATIONNOTIFICATIONSDRAWEROPEN';


